import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  requestContainer: {
    maxHeight: 350,
    overflowY: 'auto'
  },
  headerWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '20px 5px',
  },
  containerData: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  headings: {
    color: '#545456',
    fontSize: '14px',
  },
  cardWrapper: {
    margin: '20px 10px',
    padding: '10px 25px',
  },
  cardData: {
    fontSize: '12px',
    color: '#6F6F6F',
    paddingBottom: '5px'
  },
  cardValue: {
    fontSize: '20px'
  },
  link: {
    textDecoration: 'none',
    fontWeight: 'lighter',
    color: '#3b86ff'
  }
}))

export { useStyles }